import React, { useContext } from "react";
import { AuthContext } from "./context/auth-context";
import Message from "./Message";
import ProductList from "./ProductList";

const Market = () => {
  const auth = useContext(AuthContext);
  return auth.isLoggedIn ? <ProductList /> : <Message item="products" />;
};

export default Market;
